export const accordion = () => {
  const accordionSection = document.querySelectorAll('.accordion-section');

  accordionSection.forEach((accordion) => {
    const accordionButton = accordion.querySelectorAll('.accordion__header');

    const handleClick = (e) => {
      const target = e.target;
      const item = target.parentNode;
      const panel = item.querySelector('.accordion__panel');

      if (target.getAttribute('aria-expanded') === 'false') {
        target.setAttribute('aria-expanded', 'true');
      } else {
        target.setAttribute('aria-expanded', 'false');
      }

      item.classList.toggle('active');

      panel.toggleAttribute('hidden');
    };

    accordionButton.forEach((button) => {
      button.addEventListener('click', (e) => handleClick(e));
    });
  });
};
